import {UserSearchStateCriteria} from 'src/constants';
import {UserStatus} from 'src/openapi/admin/models/UserStatus';
import {UserType} from 'src/openapi/admin/models/UserType';

export const getStatusesFromState = (state: UserSearchStateCriteria | 'all'): UserStatus[] | undefined => {
    switch (state) {
        case UserSearchStateCriteria.LICENSED:
        case UserSearchStateCriteria.MOBILE:
        case UserSearchStateCriteria.CRM_ONLY:
        case UserSearchStateCriteria.CREDIT_ALERTS_ONLY:
            return [UserStatus.ENABLED];
        case UserSearchStateCriteria.FREE_NEWSLETTER:
            return [UserStatus.SUSPENDED, UserStatus.DISABLED];
        case UserSearchStateCriteria.NO_ACCESS:
            return [UserStatus.EMPTY];
        default:
            return undefined;
    }
};

export const getTypesFromState = (state: UserSearchStateCriteria | 'all'): UserType[] | undefined => {
    switch (state) {
        case UserSearchStateCriteria.LICENSED:
            return [UserType.T_LC];
        case UserSearchStateCriteria.MOBILE:
            return [UserType.T_MB];
        case UserSearchStateCriteria.CRM_ONLY:
            return [UserType.T_CRM];
        case UserSearchStateCriteria.NO_ACCESS:
            return [UserType.T_NA];
        case UserSearchStateCriteria.CREDIT_ALERTS_ONLY:
            return [UserType.T_CA];
        case UserSearchStateCriteria.FREE_NEWSLETTER:
        default:
            return undefined;
    }
};
